<template>
  <div class="candidateAvatar">
    <span
      :class="{
        'candidateAvatar__border': hasBorder,
        'candidateAvatar__circle': variant === 'circle',
      }"
    >
      <img
        :src="gravatarUrl.normal"
        :srcset="`${gravatarUrl.retina} 2x`"
        alt="User avatar"
        :width="size"
        :height="size"
        :class="{
          'candidateAvatar__circle': variant === 'circle',
        }"
      />
    </span>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'CandidateAvatar',
  props: {
    avatarId: {
      type: String,
      required: false,
    },
    variant: {
      type: String,
      required: true,
      validator: value => ['circle', 'square'].includes(value),
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 40,
    },
  },
  computed: {
    gravatarUrl() {
      const url = new URL(`https://gravatar.com/avatar/${this.avatarId}`);
      url.searchParams.set('d', 'mp');

      url.searchParams.set('s', this.size);
      const normal = url.toString();

      url.searchParams.set('s', (this.size * 2).toString());
      const retina = url.toString();

      return {
        normal,
        retina,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
.candidateAvatar {
  display: inline-flex;
}
.candidateAvatar span {
  display: inline-flex;
  width: 100%;
  aspect-ratio: 1 / 1;
  flex-shrink: 1;
  height: fit-content;
}
.candidateAvatar__border {
  border: 4px solid $husleie-light-grey;
}
.candidateAvatar__circle {
  border-radius: 50%;
}
</style>
